export default __webpack_public_path__ + "static/media/haircare.3bcf5d1b.jpg";